{
  "home": "Boendesidor",
  "contract": "Avtal",
  "defectNotice": "Felanmälan",
  "confirmContractTermination": "Bekräfta uppsägningen",
  "messages": "Meddelanden",
  "feedback": "Återföring",
  "paymentHistory": "Betalningshistoria",
  "paymentInformation": "Fakturor och betalningsuppgifter",
  "terminateContract": "Säg upp avtalet",
  "contractModification": "Avtalsändringar",
  "documents": "Dokument",
  "userInfo": "Användaruppgifter",
  "notFound": "Sidan kunde inte hittas",
  "bulletin": "Anslag",
  "building": "Fastighetsinformation",
  "bulletinBoard": "Alla anslag",
  "contactInformation": "Kontaktinformation",
  "parking": "Parkeringsplatser",
  "gymBooking": "Gymbokningar",
  "gymReservations": "Gymbokningar",
  "laundryReservations": "Tvättbokningar",
  "saunaReservations": "Bastubokningar",
  "commonAreaReservations": "Samlingslokaler",
  "storages": "Förråd"
}
